/** #1263 — presentation of the already selected native US moneyline book.
 * The Moneyline section owns its single depth reader; this component never reads. */
import { ExchangeOrderBook } from '@/components/organisms/ExchangeOrderBook';
import { usBookCurrent, usBookForOutcome, usOutcomeFor } from '@/lib/polymarketUs/gameMapping';
import type { UsMarketBookData } from '@/lib/polymarketUs/marketClient';
import type { UsBoardQuote } from '@/stores/usBoardQuotes';
import { usQuoteCurrent } from '../ValueDashboard/us/UsBoardCell';
import type { MarketSide } from '../ValueDashboard/types';

export function UsCompactMoneylineBook({ quote, book, teamCode, teamName, side, now, final, onTrade }: {
  quote: UsBoardQuote | null; book: UsMarketBookData | null;
  teamCode: string; teamName: string; side: MarketSide; now: number; final: boolean;
  onTrade(side: MarketSide, cents: number): void;
}) {
  const current = !final && quote != null && usQuoteCurrent(quote, now) && !!quote.yesTeam
    && book != null && book.marketSlug === quote.marketSlug && usBookCurrent(book, now);
  const outcome = quote?.yesTeam ? usOutcomeFor(teamCode, quote.yesTeam, side) : null;
  const ladder = current && outcome ? usBookForOutcome(book!, outcome) : null;
  const status = final ? 'Final' : current ? 'Live' : !quote ? 'No current US quote'
    : book?.marketSlug === quote.marketSlug && book.state !== 'unavailable' ? 'Stale' : 'Unavailable';
  return <section aria-label={`Polymarket US ${teamName} ${side.toUpperCase()} book`} data-testid="us-compact-book">
    <h4 className="mb-1 text-xs font-semibold">Polymarket US</h4>
    <ExchangeOrderBook venue="polymarket_us" teamLabel={`${teamName} — ${side.toUpperCase()}`}
      maxLevels={3} bids={ladder?.bids ?? []} asks={ladder?.asks ?? []}
      headerRight={<span data-testid="us-compact-book-status" className={current ? 'text-xs text-emerald-400' : 'text-xs text-amber-400'}>{status}</span>}
      onLevelClick={current ? info => {
        if (quote && book && usQuoteCurrent(quote, Date.now()) && usBookCurrent(book, Date.now())) onTrade(side, info.priceCents);
      } : undefined} />
    {ladder?.partial && <p className="mt-1 text-[10px] text-muted-foreground">Depth beyond the levels shown is not included.</p>}
  </section>;
}
